/* PH Import — PDP "Anmeldelser fra rigtige kunder" video reviews
   (native port of the Intelligems A/B winner).

   Markup is server-rendered by snippets/product-video-reviews.liquid; this only
   wires the fullscreen popup carousel (drag / dots / arrows, play-pause-replay,
   per-slide reset).

   NOTE: DESKTOP_QUERY must stay in sync with the (min-width: 1024px) block in
   product-video-reviews.css — the popup layout swap depends on both. */
(function () {
  'use strict';

  var DESKTOP_QUERY = '(min-width: 1024px)';
  var mq = window.matchMedia(DESKTOP_QUERY);

  function isDesktop() {
    return mq.matches;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function init(root) {
    if (root.getAttribute('data-phvr-ready') === '1') return;

    var modal = root.querySelector('.phvr-modal');
    var items = toArray(root.querySelectorAll('.phvr__item'));
    if (!modal || !items.length) return;

    root.setAttribute('data-phvr-ready', '1');

    // The theme editor re-renders the whole section; drop this block's previous
    // popup, which survived the re-render because it was moved out to <body>.
    var owner = modal.getAttribute('data-phvr-owner');
    if (owner) {
      toArray(document.querySelectorAll('.phvr-modal[data-phvr-owner="' + owner + '"]')).forEach(function (m) {
        if (m !== modal && m.parentNode) m.parentNode.removeChild(m);
      });
    }
    // position: fixed is unreliable inside transformed / clipped ancestors.
    document.body.appendChild(modal);

    var stage = modal.querySelector('.phvr-stage');
    var track = modal.querySelector('.phvr-track');
    var slides = toArray(modal.querySelectorAll('.phvr-slide'));
    var dots = toArray(modal.querySelectorAll('.phvr-dot'));
    var overlay = modal.querySelector('.phvr-modal__overlay');
    var prevBtn = modal.querySelector('.phvr-arrow--prev');
    var nextBtn = modal.querySelector('.phvr-arrow--next');
    var closeBtn = modal.querySelector('.phvr-close');
    if (!stage || !track || !slides.length) return;

    var players = slides.map(function (s) { return s.querySelector('video'); });
    var count = slides.length;
    var startMuted = modal.getAttribute('data-start-muted') === 'true';
    var autoplay = modal.getAttribute('data-autoplay') !== 'false';
    var index = 0;
    var lastFocused = null;
    var scrollY = 0;

    players.forEach(function (v) {
      if (!v) return;
      v.controls = false;
      v.playsInline = true;
      v.muted = startMuted;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.setAttribute('disablepictureinpicture', '');
    });

    /* ---------------------------------------------------------- slide state */
    function setSlideState(i, state) {
      var slide = slides[i];
      if (!slide || slide.getAttribute('data-state') === state) return;
      slide.setAttribute('data-state', state);
      var toggle = slide.querySelector('.phvr-toggle');
      if (toggle) {
        var label = toggle.getAttribute('data-label-' + state);
        if (label) toggle.setAttribute('aria-label', label);
      }
    }

    function safePlay(video) {
      var p = video.play();
      if (p && typeof p['catch'] === 'function') {
        p['catch'](function () {
          // Autoplay with sound refused — retry muted so the video still plays.
          video.muted = true;
          var p2 = video.play();
          if (p2 && typeof p2['catch'] === 'function') p2['catch'](function () {});
        });
      }
    }

    function resetSlide(i) {
      var v = players[i];
      if (!v) return;
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
      setSlideState(i, 'paused');
    }

    function playCurrent() {
      if (!autoplay) return;
      var v = players[index];
      if (!v) return;
      if (v.preload !== 'auto') v.preload = 'auto';
      try { v.currentTime = 0; } catch (e) {}
      safePlay(v);
    }

    slides.forEach(function (slide, i) {
      var video = players[i];
      var toggle = slide.querySelector('.phvr-toggle');
      if (!video || !toggle) return;

      video.addEventListener('play', function () { setSlideState(i, 'playing'); });
      video.addEventListener('playing', function () { setSlideState(i, 'playing'); });
      video.addEventListener('pause', function () {
        if (!video.ended) setSlideState(i, 'paused');
      });
      video.addEventListener('ended', function () { setSlideState(i, 'ended'); });

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var state = slide.getAttribute('data-state');
        if (state === 'playing') {
          video.pause();
          return;
        }
        if (state === 'ended') {
          try { video.currentTime = 0; } catch (err) {}
        }
        if (video.preload !== 'auto') video.preload = 'auto';
        safePlay(video);
      });
    });

    /* ------------------------------------------------------------- carousel */
    function setTransform(extraPx) {
      var pct = -index * 100;
      var offset = extraPx ? 'calc(' + pct + '% + ' + extraPx + 'px)' : pct + '%';
      track.style.transform = isDesktop()
        ? 'translate3d(0,' + offset + ',0)'
        : 'translate3d(' + offset + ',0,0)';
    }

    function syncControls() {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === count - 1;
    }

    function goTo(i, opts) {
      i = Math.max(0, Math.min(count - 1, i));
      var instant = opts && opts.instant;

      players.forEach(function (_, n) { if (n !== i) resetSlide(n); });
      if (i !== index || (opts && opts.force)) resetSlide(i);

      index = i;

      if (instant) {
        track.classList.add('no-anim');
        setTransform();
        void track.offsetWidth; // flush
        track.classList.remove('no-anim');
      } else {
        setTransform();
      }

      syncControls();
      playCurrent();
    }

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

    /* ----------------------------------------------------------------- drag */
    (function bindDrag() {
      var active = false, decided = false, dragging = false;
      var startX = 0, startY = 0, delta = 0, startTime = 0, pointerId = null;

      function size() {
        return isDesktop() ? stage.offsetHeight : stage.offsetWidth;
      }

      stage.addEventListener('pointerdown', function (e) {
        if (e.button != null && e.button !== 0) return;
        active = true; decided = false; dragging = false;
        delta = 0;
        startX = e.clientX; startY = e.clientY;
        startTime = Date.now();
        pointerId = e.pointerId;
      });

      stage.addEventListener('pointermove', function (e) {
        if (!active || e.pointerId !== pointerId) return;
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        var main = isDesktop() ? dy : dx;
        var cross = isDesktop() ? dx : dy;

        if (!decided) {
          if (Math.abs(main) < 6 && Math.abs(cross) < 6) return;
          decided = true;
          if (Math.abs(main) < Math.abs(cross)) { active = false; return; }
          dragging = true;
          track.classList.add('is-dragging');
          try { stage.setPointerCapture(pointerId); } catch (err) {}
        }

        // resistance at the ends
        if ((index === 0 && main > 0) || (index === count - 1 && main < 0)) {
          main = main * 0.32;
        }
        delta = main;
        setTransform(delta);
      });

      function endDrag(e) {
        if (!active) return;
        if (e && pointerId != null && e.pointerId !== pointerId) return;
        active = false;
        try { stage.releasePointerCapture(pointerId); } catch (err) {}

        if (!dragging) { pointerId = null; return; }
        track.classList.remove('is-dragging');

        var elapsed = Date.now() - startTime;
        var velocity = Math.abs(delta) / Math.max(elapsed, 1); // px per ms
        var passed = Math.abs(delta) > size() * 0.18 || velocity > 0.5;
        var target = index;
        if (passed) target = delta < 0 ? index + 1 : index - 1;
        target = Math.max(0, Math.min(count - 1, target));

        if (target === index) setTransform();
        else goTo(target);

        dragging = false;
        pointerId = null;
      }

      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);

      // Swallow the click that follows a drag so the play/pause button
      // doesn't fire at the end of a swipe.
      stage.addEventListener(
        'click',
        function (e) {
          if (Math.abs(delta) > 6) {
            e.stopPropagation();
            e.preventDefault();
            delta = 0;
          }
        },
        true
      );

      stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    })();

    /* --------------------------------------------------------- open / close */
    function lockScroll() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = -scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    function open(i) {
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      lockScroll();
      index = i;
      goTo(i, { instant: true, force: true });
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function close() {
      if (!modal.classList.contains('is-open')) return;
      players.forEach(function (_, n) { resetSlide(n); });
      modal.classList.remove('is-open');
      unlockScroll();
      if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    }

    items.forEach(function (item, i) {
      item.addEventListener('click', function () { open(i); });
    });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { goTo(index - 1); return; }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { goTo(index + 1); return; }
      if (e.key === 'Tab') {
        var focusables = modal.querySelectorAll('button:not([disabled])');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });

    function onBreakpointChange() {
      track.classList.add('no-anim');
      setTransform();
      void track.offsetWidth;
      track.classList.remove('no-anim');
    }
    if (mq.addEventListener) mq.addEventListener('change', onBreakpointChange);
    else if (mq.addListener) mq.addListener(onBreakpointChange);

    /* -------------------------------------- lazy poster frames (URL fallback)
       Only used for thumbnails that have no poster image (plain .mp4 URL, no
       Shopify video object): pull the first frame once the block nears the
       viewport, the same way the A/B variant did. */
    var lazyVideos = toArray(root.querySelectorAll('video[data-phvr-lazy]'));
    if (lazyVideos.length) {
      var loadLazy = function () {
        lazyVideos.forEach(function (v) {
          if (v.preload === 'none') { v.preload = 'metadata'; v.load(); }
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              loadLazy();
              io.unobserve(entry.target);
            });
          },
          { rootMargin: '400px 0px' }
        );
        io.observe(root);
      } else {
        loadLazy();
      }
    }

    setTransform();
    syncControls();
  }

  function initAll(scope) {
    var node = scope && scope.querySelectorAll ? scope : document;
    if (node.classList && node.classList.contains('phvr')) init(node);
    toArray(node.querySelectorAll('.phvr')).forEach(init);
  }

  ready(function () { initAll(document); });

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    toArray(e.target.querySelectorAll('.phvr')).forEach(function (root) {
      var id = root.getAttribute('data-phvr-id');
      if (!id) return;
      toArray(document.querySelectorAll('.phvr-modal[data-phvr-owner="' + id + '"]')).forEach(function (m) {
        if (m.parentNode) m.parentNode.removeChild(m);
      });
    });
  });
})();
